import { render, staticRenderFns } from "./TdConversionAttributeCreateAndUpdate.vue?vue&type=template&id=587ca2cc&scoped=true"
import script from "./TdConversionAttributeCreateAndUpdate.vue?vue&type=script&lang=ts"
export * from "./TdConversionAttributeCreateAndUpdate.vue?vue&type=script&lang=ts"
import style0 from "./TdConversionAttributeCreateAndUpdate.vue?vue&type=style&index=0&id=587ca2cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "587ca2cc",
  null
  
)

/* custom blocks */
import block0 from "@/i18n/views/client-settings/td-conversion-attribute-create-and-update.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fusergram-front%2Fsrc%2Fviews%2Fclient-settings%2FTdConversionAttributeCreateAndUpdate.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports